module.exports = __webpack_public_path__ + "img/content6-6.77351554.webp";